import * as Data from 'effect/Data';
import { Bic, LegacyBic } from './bic.model';

/** A Bank. */
export interface Bank {
  readonly _tag: 'Bank';
  /** The name of the bank. */
  readonly name: string;
  /** The BIC of the bank. */
  readonly bic: Bic;
}
export const Bank = Data.tagged<Bank>('Bank');

/**
 * @deprecated Use {@link Bank} instead.
 */
export class LegacyBank {
  private _name: string;
  private _bic: LegacyBic;

  constructor(name: string, bic: string) {
    this._name = name;
    this._bic = new LegacyBic(bic);
  }

  /**
   * The name of the bank
   */
  public get name(): string {
    return this._name;
  }

  /**
   * The BIC of the bank
   */
  public get bic(): LegacyBic {
    return this._bic;
  }
}
